"use client";

import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import PromotionForm from "./PromotionForm";
import PromotionTable from "./PromotionTable";
import OwnerGroup from "../components/OwnerGroup";
import { useGlobalState } from "../utils/GlobalStateContext";

function Promotions() {
  const [open, setOpen] = useState(false);
  const { state: globalState, dispatch } = useGlobalState();
  const { ownerGroups } = globalState;

  const [ownerGroup, setOwnerGroup] = useState();

  useEffect(() => {
    if (ownerGroups && ownerGroups.length > 0) {
      setOwnerGroup(ownerGroups[0].id);
    }
  }, [ownerGroups]);

  const handleOwnerGroupChange = (event) => {
    setOwnerGroup(event.target.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Paper elevation={6}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', alignItems: 'flex-end', justifyContent: 'flex-start', marginBottom: '2rem', marginLeft: 'auto' }}>
          <p style={{ fontSize: '1.25rem', marginLeft: '2rem', marginBottom: '2rem' }}>My Promotions</p>
          {/*
          <span style={{ margin: '2rem', marginLeft: 'auto', height: '1.75rem' }}>Select Owner Group</span>
          <OwnerGroup
            handleSelection={handleOwnerGroupChange}
            selectedValue={ownerGroup}
            options={ownerGroups}
          />
          */}
          <Button
            style={{ margin: '2rem', marginLeft: 'auto', height: '1.75rem' }}
            variant="contained"
            onClick={handleClickOpen}
            startIcon={<AddIcon />}
          >
            Create New Promotion
          </Button>
        </div>
      </Paper>
      <PromotionTable ownerGroup={ownerGroup} />
      <PromotionForm
        open={open}
        handleClose={handleClose}
        ownerGroup={ownerGroup}
        editMode={false}
      />
    </>
  );
}

export default Promotions;
